import { useFormContext } from "react-hook-form";
import { PaymentSection } from "../sections/payment/PaymentSection";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface PaymentDetailsProps {
  amount: number;
  taxReturnId: string;
  serviceId: string;
  onPaymentSuccess: (paymentIntentId: string) => void;
}

export function PaymentDetails({ amount, taxReturnId, serviceId, onPaymentSuccess }: PaymentDetailsProps) {
  if (!taxReturnId || !serviceId) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>Required information is missing. Please try again.</AlertDescription>
      </Alert>
    );
  }

  return (
    <PaymentSection
      amount={amount}
      taxReturnId={taxReturnId}
      serviceId={serviceId}
      onPaymentSuccess={onPaymentSuccess}
    />
  );
}